import React, {useState} from 'react';
import ExceptionDetails from './ExceptionDetails';

const INITIAL_KEY_INDEX = 0;
const ADD_KEY_INDEX = 1;

function AttemptMatching() {
  const [key, setKey] = useState(INITIAL_KEY_INDEX);

  const resetComponent = () => {
    setKey(prevKey => prevKey + ADD_KEY_INDEX);
  };

  return (
    <div>
      <ExceptionDetails key={key} resetComponent={resetComponent} />
    </div>
  );
}

export default AttemptMatching